const QA_DEFAULTS = [
  'future',
  'next',
  'try',
  'localhost',
  'corp-staging',
  'corp.rei.com',
  'reioms.stage-oms',
  'training.next-rentals',
  'rei-blog-develop',
  'rei-cloud',
  'rei.porbeta.com',
];

const PROD_DEFAULT = [
  'www.rei.com',
  'destination.rei.com',
  'reioms.ourgiftcards.com',
  'rentals.rei.com',
];

const GPC_LOCAL_STORAGE_KEY = 'sscid-gpc-status';
const SUCCESFUL_OPTOUT_STATUS = '201';

export {
  QA_DEFAULTS,
  PROD_DEFAULT,
  SUCCESFUL_OPTOUT_STATUS,
  GPC_LOCAL_STORAGE_KEY,
};
